import { o, join, adjust, toUpper, unless, isEmpty } from 'ramda';
var adjustFirstLetter = /*#__PURE__*/o( /*#__PURE__*/join(''), /*#__PURE__*/adjust(0, toUpper));
/**
 * Capitalize first letter.
 *
 * @func
 * @category String
 *
 * @example
 *
 *        R_.toUpperFirst('') // ''
 *        R_.toUpperFirst('hello world') // 'Hello world'
 *
 * @sig String -> String
 */

var toUpperFirst = /*#__PURE__*/unless(isEmpty, adjustFirstLetter);
export default toUpperFirst;